import { US_STATES } from '@hts/shared';
import type { License } from '../types';

interface LicenseFormProps {
  licenses: License[];
  onChange: (licenses: License[]) => void;
}

const EMPTY_LICENSE: License = { type: '', number: '', state: '', expiresAt: '' };

export function LicenseForm({ licenses, onChange }: LicenseFormProps) {
  const addRow = () => onChange([...licenses, { ...EMPTY_LICENSE }]);

  const removeRow = (index: number) => {
    onChange(licenses.filter((_, i) => i !== index));
  };

  const updateRow = (index: number, field: keyof License, value: string) => {
    const updated = licenses.map((lic, i) =>
      i === index ? { ...lic, [field]: value } : lic,
    );
    onChange(updated);
  };

  return (
    <div>
      {licenses.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 80px 140px 40px', gap: 8, marginBottom: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: '#6B7280' }}>Type</span>
          <span style={{ fontSize: 12, fontWeight: 600, color: '#6B7280' }}>Number</span>
          <span style={{ fontSize: 12, fontWeight: 600, color: '#6B7280' }}>State</span>
          <span style={{ fontSize: 12, fontWeight: 600, color: '#6B7280' }}>Expires</span>
          <span />
        </div>
      )}

      {licenses.map((lic, i) => (
        <div key={i} className="license-row">
          <input
            type="text"
            placeholder="e.g. Electrical"
            value={lic.type}
            onChange={(e) => updateRow(i, 'type', e.target.value)}
          />
          <input
            type="text"
            placeholder="License #"
            value={lic.number}
            onChange={(e) => updateRow(i, 'number', e.target.value)}
          />
          <select value={lic.state} onChange={(e) => updateRow(i, 'state', e.target.value)}>
            <option value="">--</option>
            {US_STATES.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
          <input
            type="date"
            value={lic.expiresAt}
            onChange={(e) => updateRow(i, 'expiresAt', e.target.value)}
          />
          <button type="button" className="btn-icon" onClick={() => removeRow(i)} title="Remove">
            &times;
          </button>
        </div>
      ))}

      <button type="button" className="btn btn-secondary" onClick={addRow} style={{ marginTop: 8 }}>
        + Add License
      </button>
    </div>
  );
}
